<template>
    <div ref="form">
        <div class="vx-card__title mb-4">
            <h4 class="mb-4">{{ heading }}</h4>
            <p v-if="verifying">Please wait...</p>
            <p v-else-if="success">
                The email address: <a :href="localEmail">{{ localEmail }}</a> has been successfully
                verified, feel free to login at any time.
            </p>
            <p v-else>We could not verify your email.</p>
        </div>

        <div>
            <vx-button :disabled="verifying" class="float-right mt-4" @click="goToLogin"
                >Proceed to Login</vx-button
            >
        </div>
    </div>
</template>

<script>
import { mapQueries } from '../../../plugins/mappers'
export default {
    name: 'verify-email',
    props: {
        email: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            verifying: true,
            success: null
        }
    },
    computed: {
        ...mapQueries('token'),
        localEmail: {
            get() {
                return this.email
            },
            set(val) {
                this.$emit('update:email', val)
            }
        },
        heading() {
            if (this.verifying) {
                return 'Verifying Your Email'
            } else if (this.success) {
                return 'Email Verified'
            } else {
                return 'Invalid Link'
            }
        }
    },
    async mounted() {
        if (!this.token) {
            this.$router.push({ name: '404' })
        }

        this.startLoad(this.$refs.form)
        try {
            var response = await this.$api.auth.verify_email(this.token)
            this.localEmail = response.email
            this.success = true
        } catch (error) {
            this.notifyServerError(error)
            this.success = false
        } finally {
            this.endLoad(this.$refs.form)
            this.verifying = false
        }
    },
    goToLogin() {
        this.$router.push('/account/login')
    }
}
</script>
